import React, { FC } from 'react'
import makeStyles from '@mui/styles/makeStyles'
import Box from '@mui/material/Box'
import { SxProps } from '@mui/system'

interface StyleProps {
  fontSize?: string,
  color?: string,
}
const useStyles = makeStyles(theme => ({
  root: ({fontSize, color}: StyleProps) => ({
    fontSize,
    color: color || theme.palette.grey[500],
  }),
}))

interface SmallTextProps {
  fontSize?: string,
  color?: string,
  className?: string,
  sx?: SxProps,
}

const SmallText: FC<React.PropsWithChildren<SmallTextProps>> = ({
  fontSize = '0.8em',
  color,
  className,
  sx,
  children,
}) => {

  const classes = useStyles({fontSize, color})
  
  return (
    <Box component="span" className={ `${classes.root} ${className || ''}` } sx={ sx }>
      { children }
    </Box>
  )
}

export default SmallText